import { R } from '@core/utils/r';
import { CourseInboxResponse, CourseInboxId, CourseInboxSearchParams, UnreadInboxMessages } from '@business/entities/course_inbox';
import { Endpoint } from '@business/api/endpoint';

export function fetchCourseInboxs(params?: CourseInboxSearchParams) {
  return Endpoint.get<CourseInboxResponse[]>(`@makh/instructor-inbox`, { params: R.objectCompact(params) });
}

export function createCourseInbox(data: Partial<CourseInboxResponse>) {
  return Endpoint.post<CourseInboxResponse>(`@makh/instructor-inbox`, { data });
}

export function updateCourseInbox(id: CourseInboxId, data: Partial<CourseInboxResponse>) {
  return Endpoint.patch<CourseInboxResponse>(`@makh/instructor-inbox/${id}`, { data });
}

export function deleteCourseInbox(id: CourseInboxId) {
  return Endpoint.delete<void>(`@makh/instructor-inbox/${id}`);
}

export function fetchCourseInbox(id: CourseInboxId) {
  return Endpoint.get<CourseInboxResponse>(`@makh/instructor-inbox/instructor-inbox/${id}`);
}

export function getUnreadMessages() {
  return Endpoint.get<UnreadInboxMessages>(`@makh/instructor-inbox/unread`);
}
